import { gql } from '@apollo/client';

const entitlementDetails = gql`
  fragment entitlementDetails on CloudSiteProduct {
    accountId
    id
    sen
    baseProduct
    isAddon
    edition
    editionKey
    firstPeriodStartDate
    latestPeriodStartDate
    latestPeriodEndDate
    isCloud
    productId
    productName
    billingStatus
    planType
    unitCount
    unitLabel
    cloudSiteUrl
    endTimestamp
    billingFrequency
    entitlementNumber
    sourceSystem
    futureEditionKey
    overriddenEdition
    trialStartDate
    trialEndDate
    region
    nextBillingTimestamp
    pricingPlan {
      type
    }
    extendedCloudTrial {
      btfSourceAccountId
      usageLimit
      usageType
    }
    userTier
    transactionAccountId
    transactionAccountNumber
    transactionAccountName
    billToParty {
      name
      addressLine1
      addressLine2
      city
      state
      country
      postcode
      taxId
    }
    trial
    billedUsers
    defaultPaymentMethod {
      id
      type
      paymentIssue
      default
      ... on CreditCard {
        card {
          expirationMonth
          expirationYear
          last4Numbers
          brand
        }
      }
      ... on PaymentOnTerms {
        terms {
          invoiceDueDays
        }
      }
    }
    billingCycle
    provisioningStatus
    isSandbox
    isApp
    activeUsers
    logoId
    upgradeTrial {
      offeringName
      offeringId
      baseOfferingName
    }
    scheduledChanges {
      subscriptionScheduleAction
    }
  }
`;

const productAppSubscription = gql`
  ${entitlementDetails}
  fragment productAppSubscription on ProductAppSubscriptionForCloudSite {
    products {
      ...entitlementDetails
    }
    apps {
      ...entitlementDetails
    }
  }
`;

export const fetchCloudSiteProductAppAndSubscriptions = gql`
  ${productAppSubscription}
  query fetchCloudSiteProductAppAndSubscriptions($parentSen: String!, $cloudSiteId: String, $showCcpData: Boolean) {
    cloudSiteProductsAppsAndSubscriptions(parentSen: $parentSen, cloudSiteId: $cloudSiteId, showCcpData: $showCcpData) {
      jira {
        ...productAppSubscription
      }
      statuspage {
        ...productAppSubscription
      }
      confluence {
        ...productAppSubscription
      }
      other {
        ...productAppSubscription
      }
    }
  }
`;

export const fetchCloudSiteProducts = gql`
  ${entitlementDetails}
  query fetchCloudSiteProductsV2(
    $parentSen: String!
    $cloudSiteId: String
    $searchOptions: CloudSiteProductsSearchOptions
    $showCcpData: Boolean
  ) {
    cloudSiteProducts(
      parentSen: $parentSen
      cloudSiteId: $cloudSiteId
      searchOptions: $searchOptions
      showCcpData: $showCcpData
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        ...entitlementDetails
      }
    }
  }
`;
